import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

/* ***************************************************************************
 * AttachmentPendingTile — CON-1930
 * Stands in the attachment row for each file that is still being compressed
 * and uploaded, so a pick or a paste shows something the moment it happens
 * rather than nothing for a second or more. Sized by the caller to match the
 * thumbnails beside it (78 px in Connections, 208 x 152 in AttachmentField).
 *************************************************************************** */
function AttachmentPendingTile({
  width = 78,
  height = 78,
  label = 'Adding attachment',
  style = {},
}) {
  return (
    <Box
      role="status"
      aria-label={label}
      title={label}
      style={style}
      sx={{
        width,
        height,
        flexShrink: 0,
        borderRadius: '4px',
        border: '1px dashed #BDBDBD',
        backgroundColor: '#F5F5F5',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress size={Math.min(28, Math.round(Math.min(width, height) / 3))} />
    </Box>
  );
}

AttachmentPendingTile.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.string,
  style: PropTypes.object,
};

export default AttachmentPendingTile;
